// SNWEB-2205 — helpers to keep the livetracker's active tab (and selected
// video) in sync with the URL:
//   /:sport/:league/games/:gamecode/:tab?/:videoId?

import { sanitizeString } from './shared_helpers';

// 'Live Game' -> 'live-game', 'Line combinations' -> 'line-combinations'.
// Delegates to sanitizeString (also used for tab identifiers in TabsDropdown)
// so URL slugs and tab ids cannot drift apart; the extra passes only guard
// against repeated/edge dashes, which sanitizeString does not normalize.
export const slugifyTab = displayName =>
	sanitizeString(String(displayName || '').trim())
		.replace(/-+/g, '-')
		.replace(/(^-|-$)/g, '');

// The game page base: first four segments (/:sport/:league/games/:gamecode),
// regardless of any tab/video suffix.
export const getGameBasePath = pathname => {
	const parts = String(pathname || '')
		.split('/')
		.filter(Boolean);
	return '/' + parts.slice(0, 4).join('/');
};

export const isGamePagePath = pathname =>
	String(pathname || '')
		.split('/')
		.filter(Boolean)[2] === 'games';

// For consumers that key off the pathname (ad targeting, canonical URLs):
// a game page's tab/video segments are view state, not identity — strip them.
export const stripGameTabSegments = pathname => (isGamePagePath(pathname) ? getGameBasePath(pathname) : pathname);

// True when two pathnames refer to the same game page (only the tab/video
// segments differ). Used to avoid tearing down websockets / re-fetching game
// data / scrolling to top on tab-only URL changes.
export const isSameGamePage = (prevPathname, nextPathname) => {
	if (!isGamePagePath(prevPathname) || !isGamePagePath(nextPathname)) {
		return false;
	}
	const prev = String(prevPathname)
		.split('/')
		.filter(Boolean);
	const next = String(nextPathname)
		.split('/')
		.filter(Boolean);
	return prev[0] === next[0] && prev[1] === next[1] && prev[3] === next[3] && prev[3] !== undefined;
};
